import { useEffect } from "react";

/**
 * Sets the page title.
 *
 * @param enabled - Whether to set the title.
 * @param title - The title to set.
 */
export const useSetTitle = ({
  enabled = true,
  title,
}: {
  enabled?: boolean;
  title: string;
}) => {
  useEffect(() => {
    if (!enabled) return;

    document.title = title;
  }, [enabled, title]);
};
